import template from './product-check-item.template.html';
import './product-check-item.scss';

export default {
  template,
  bindings: {
    labels: '<',
  },
  transclude: {
    action: '?productCheckItemAction',
    accordion: '?productCheckItemAccordion',
  },
};



// WEBPACK FOOTER //
// ./src/app/product/product-check/product-check-item/product-check-item.component.js